import { render } from "./ChangePasswordLayout.vue?vue&type=template&id=70929ef4"
import script from "./ChangePasswordLayout.vue?vue&type=script&lang=js"
export * from "./ChangePasswordLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__